export * from '@stadionhq-v3/scottishfa-web-tokens/dist/components/icons';
export * from './flag';
export * from './static';
